import { AuthChangeEvent, Session } from '@supabase/supabase-js';

export const setAuthCookie = async (session: Session | null, event: AuthChangeEvent) => {
  await fetch('/api/set-auth-cookie', {
    method: 'POST',
    headers: new Headers({ 'content-Type': 'application/json' }),
    body: JSON.stringify({ session, event }),
  });
};
